import React, { useContext } from 'react'
import { IMultistepComponent } from 'interfaces/i-multistep'
import Multistep from 'components/multistep/Multistep'
import ApplicationDataViewUk from 'components/application-blocks/application-offer-blocks/ApplicationDataViewUk/ApplicationDataViewUk'
import ThankYou from 'components/application-blocks/common-blocks/ThankYou/ThankYou'
import { FillPersonalDataUK } from 'components/application-blocks/application-offer-blocks/FillPersonalData/FillPersonalDataUK'
import { IApplicationContext } from 'interfaces/i-application-context-props'
import { ApplicationDispatchContext } from 'contexts/ApplicationContext'
import { LifeCycleStatus } from 'constants/enums/lifeCycleStatus'
import { CheckIsLifeCycleStatus } from 'utils/loanHelpers'
import { SignPnUK } from 'components/application-blocks/application-offer-blocks/SignPn/SignPnUK'

export const CreditCardApplicationStepsUk = () => {
	const { loanApplication }: IApplicationContext = useContext(
		ApplicationDispatchContext,
	)
	const creditCardApplicationSteps: IMultistepComponent[] = [
		{
			id: 1,
			header: 'ApplicationDataViewHeader',
			body: <ApplicationDataViewUk />,
			show: true,
			stepCompleted: false,
		},
		{
			id: 2,
			header: 'UpdateApplication',
			body: <FillPersonalDataUK />,
			show: CheckIsLifeCycleStatus(
				[LifeCycleStatus.Offering],
				loanApplication.applicationData?.lifeCycleStatus!,
			),
			stepCompleted: false,
		},
		{
			id: 3,
			header: 'SignContractHeader',
			body: <SignPnUK />,
			show: true,
			stepCompleted: false,
		},
		{
			id: 4,
			header: 'ThankYouHeaderCreditCard',
			body: <ThankYou />,
			show: true,
			stepCompleted: false,
		},
	]

	return (
		<Multistep
			multisteps={creditCardApplicationSteps}
			resetInitialState={false}
		/>
	)
}
